export default __webpack_public_path__ + "8094fe577616f53f217290fa823f1bf2.ttf";